// third-party
import { yellow } from '@ant-design/colors';

// project imports
import i18n from '@/i18n';

// types
import { ErrorCategory } from './types';

// ==============================|| ERRORS - CATEGORY → UI (paleta semantică) ||============================== //
// Sursa unică pentru felul în care o categorie de eroare se colorează/etichetează în UI
// (toast + dialog), în ordinea severității: server/rețea = error (roșu), validare BE 4xx
// = warning (portocaliul/gold al temei), runtime FE = GALBEN (presetul Ant `yellow` —
// tema nu are variantă semantică galbenă, deci toastul primește un override explicit de
// culoare; ca variantă/ton de fallback rămâne warning).

export type ErrorToastVariant = 'error' | 'warning' | 'info';

export const CATEGORY_TOAST_VARIANT: Record<ErrorCategory, ErrorToastVariant> = {
	server: 'error',
	validation: 'warning',
	runtime: 'warning'
};

// Override de culoare pentru categoriile fără variantă semantică proprie. Text închis pe
// galben (contrastul textului deschis pe #fadb14 ar fi ilizibil).
export const CATEGORY_TOAST_COLORS: Partial<
	Record<ErrorCategory, { main: string; contrastText: string }>
> = {
	runtime: { main: yellow[5], contrastText: '#262626' }
};

// Titlurile/etichetele sunt chei i18n (grupul `errors` — editabile din Gestionare texte)
// cu fallback hardcodat prin defaultValue; FUNCȚII (nu constante), ca să fie evaluate la
// momentul folosirii — după aplicarea override-urilor de texte din BE.
const TOAST_TITLE_FALLBACK: Record<ErrorCategory, string> = {
	server: 'Eroare de server',
	runtime: 'Eroare în aplicație',
	validation: 'Cerere respinsă'
};

const TOAST_TITLE_KEY: Record<ErrorCategory, string> = {
	server: 'errors.toastTitleServer',
	runtime: 'errors.toastTitleRuntime',
	validation: 'errors.toastTitleValidation'
};

export const categoryToastTitle = (category: ErrorCategory): string =>
	i18n.t(TOAST_TITLE_KEY[category], { defaultValue: TOAST_TITLE_FALLBACK[category] });

// eticheta categoriei pentru chip-uri/list entries (dialogul de log)
const LABEL_FALLBACK: Record<ErrorCategory, string> = {
	server: 'Server / rețea',
	runtime: 'Aplicație (FE)',
	validation: 'Validare (BE)'
};

const LABEL_KEY: Record<ErrorCategory, string> = {
	server: 'errors.categoryServer',
	runtime: 'errors.categoryRuntime',
	validation: 'errors.categoryValidation'
};

export const categoryLabel = (category: ErrorCategory): string =>
	i18n.t(LABEL_KEY[category], { defaultValue: LABEL_FALLBACK[category] });
